module.exports = __webpack_public_path__ + "static/img/bm-payment.aa5dc88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/bm-payment.svg
// module id = tiwE
// module chunks = 3